export default __webpack_public_path__ + "static/media/rnr-sports-table-25-cn.65bad997.webp";